import { IRevenueSpendCrudModalLang, REVENUE_SPEND_CRUD_MODAL_LANG_KEY } from './interface.IRevenueSpendCrudModalLang'
import { IRevenueSpendPageLang, REVENUE_SPEND_PAGE_LANG_KEY } from './interface.IRevenueSpendPageLang'
import { IRevenueSpendListTableLang, REVENUE_SPEND_LIST_TABLE_LANG_KEY } from './interface.IRevenueSpendListTableLang'
import {
	IRevenueSpendByAccountListTableLang,
	REVENUE_SPEND_BY_ACCOUNT_LIST_TABLE_LANG_KEY
} from './interface.IRevenueSpendByAccountListTableLang'
import {
	IRevenueSpendByAccountRevenueDetailsTableLang,
	REVENUE_SPEND_BY_ACCOUNT_REVENUE_DETAILS_TABLE_LANG_KEY
} from './interface.IRevenueSpendByAccountRevenueDetailsTableLang'
import {
	IRevenueSpendByAccountOfferSpendDetailsTableLang, REVENUE_SPEND_BY_ACCOUNT_OFFER_SPEND_DETAILS_TABLE_LANG_KEY
} from './interface.IRevenueSpendByAccountOfferSpendDetailsTableLang'
import {
	IRevenueSpendByAccountSpendDetailsTableLang,
	REVENUE_SPEND_BY_ACCOUNT_SPEND_DETAILS_TABLE_LANG_KEY
} from './interface.IRevenueSpendByAccountSpendDetailsTableLang'
import {
	IRevenueSpendByAccountPageLang,
	REVENUE_SPEND_BY_ACCOUNT_PAGE_LANG_KEY
} from './interface.IRevenueSpendByAccountPageLang'
import {
	IRevenueSpendByTeamPageLang,
	REVENUE_SPEND_BY_TEAM_PAGE_LANG_KEY
} from './interface.IRevenueSpendByTeamPageLang'

export * from './interface.IRevenueSpendCrudModalLang'
export * from './interface.IRevenueSpendPageLang'
export * from './interface.IRevenueSpendListTableLang'
export * from './interface.IRevenueSpendByAccountListTableLang'
export * from './interface.IRevenueSpendByAccountRevenueDetailsTableLang'
export * from './interface.IRevenueSpendByAccountOfferSpendDetailsTableLang'
export * from './interface.IRevenueSpendByAccountSpendDetailsTableLang'
export * from './interface.IRevenueSpendByAccountPageLang'
export * from './interface.IRevenueSpendByTeamPageLang'

export type IRevenueSpendAllLang =
	& IRevenueSpendPageLang
	& IRevenueSpendCrudModalLang
	& IRevenueSpendListTableLang
	& IRevenueSpendByAccountListTableLang
	& IRevenueSpendByAccountRevenueDetailsTableLang
	& IRevenueSpendByAccountOfferSpendDetailsTableLang
	& IRevenueSpendByAccountSpendDetailsTableLang
	& IRevenueSpendByAccountPageLang
	& IRevenueSpendByTeamPageLang

export const REVENUE_SPEND_ALL_LANG_KEY: IRevenueSpendAllLang = {
	...REVENUE_SPEND_CRUD_MODAL_LANG_KEY,
	...REVENUE_SPEND_LIST_TABLE_LANG_KEY,
	...REVENUE_SPEND_PAGE_LANG_KEY,
	...REVENUE_SPEND_BY_ACCOUNT_LIST_TABLE_LANG_KEY,
	...REVENUE_SPEND_BY_ACCOUNT_REVENUE_DETAILS_TABLE_LANG_KEY,
	...REVENUE_SPEND_BY_ACCOUNT_OFFER_SPEND_DETAILS_TABLE_LANG_KEY,
	...REVENUE_SPEND_BY_ACCOUNT_SPEND_DETAILS_TABLE_LANG_KEY,
	...REVENUE_SPEND_BY_ACCOUNT_PAGE_LANG_KEY,
	...REVENUE_SPEND_BY_TEAM_PAGE_LANG_KEY
}